import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { viewModelToRoomInputConverter } from "../../../repository/_common/view-model-to-room-input";
import { useCreateRoomMutation } from "../../../repository/new/mutation/use-create-room-mutation";

import type { ProductRoomFormModel } from "../../../type";

type Props = {
	viewModel: ProductRoomFormModel["ViewModel"];
	onResetViewModel: () => void;

	onCreateRoomSuccessCallback: () => void;
};

export const useRoomCreate = ({ viewModel, onResetViewModel, onCreateRoomSuccessCallback }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onCreateRoom: _onCreateRoom } = useCreateRoomMutation();
	/**
	 * @todo 副作用を UI で定義
	 */
	const onCreateRoom = useCallback(async () => {
		showLoadingScreenCallback();

		const input = viewModelToRoomInputConverter({ viewModel });
		const { errors } = await _onCreateRoom(input).finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "部屋を作成しました",
			});
			onResetViewModel();
			onCreateRoomSuccessCallback();
		}
	}, [
		_onCreateRoom,
		hideLoadingScreenCallback,
		onResetViewModel,
		onCreateRoomSuccessCallback,
		showLoadingScreenCallback,
		viewModel,
	]);

	return {
		onCreateRoom,
	};
};
